'use strict';

var _ = require('lodash');
var SerializeRuleService = function SerializeRuleService(conditionSerializer, actionSerializer, rulesService, strategyClosureActionService, strategyAllocationAuthAvailActionService, conditionsAndActionsService, StrategyCondition) {
  function parseRule(rule) {
    if (rulesService.isQuickRule(rule)) {
      parseQuickRule(rule);
    }
    if (rulesService.isCustomRule(rule)) {
      parseCustomRule(rule);
    }
    return rule;
  }
  function parseQuickRule(rule) {
    var ruleLevel = rule.subject.level;
    if (rule.subject.conditions) {
      rule.subject.parsedConditions = conditionSerializer.deserialize(ruleLevel, rule.type, rule.flowType, rule.subject.conditions);
    }
    if (rulesService.isQuickRuleWithLevel(rule)) {
      parseQuickRuleWithLevel(rule);
    }
    if (rulesService.hasClassClosureTemplate(rule)) {
      parseClassClosureRule(rule);
    }
    if (rulesService.hasAllocationAuthAvailTemplate(rule)) {
      parseAllocationAuthAvailRule(rule);
    }
  }
  function parseQuickRuleWithLevel(rule) {
    var strategy = rule.strategies[0];
    var ruleLevel = rule.subject.level;
    rule.subject.parsedLevel = conditionsAndActionsService.getLevelByDomain(ruleLevel).label;
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        if (statement.conditions !== '') {
          statement.parsedConditions = conditionSerializer.deserialize(ruleLevel, rule.type, rule.flowType, statement.conditions);
        }
      });
    }
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        statement.parsedActions = actionSerializer.deserialize(statement, rule.type);
      });
    }
  }
  function parseClassClosureRule(rule) {
    var strategy = rule.strategies[0];
    var ruleLevel = rule.subject.level;
    if (rulesService.isQuickRuleWithTemplate(rule)) {
      if (rule.strategies[0].commonConditions) {
        strategy.parsedCommonConditions = conditionSerializer.deserialize(ruleLevel, rule.type, rule.flowType, rule.strategies[0].commonConditions);
      } else {
        strategy.parsedCommonConditions = [new StrategyCondition({})];
      }
    }
    var conditionGroups = [];
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        conditionGroups.push(conditionSerializer.parse(statement.conditions));
      });
    }
    if (!strategy.actionList) {
      strategy.actionList = strategyClosureActionService.getActionList(conditionGroups);
      strategyClosureActionService.adjustLoadFactorValues(strategy.actionList);
    }
  }
  function parseAllocationAuthAvailRule(rule) {
    var strategy = rule.strategies[0];
    var ruleLevel = rule.subject.level;
    if (rulesService.isQuickRuleWithTemplate(rule)) {
      if (rule.strategies[0].commonConditions) {
        strategy.parsedCommonConditions = conditionSerializer.deserialize(ruleLevel, rule.type, rule.flowType, rule.strategies[0].commonConditions);
      } else {
        strategy.parsedCommonConditions = [new StrategyCondition({})];
      }
    }
    var conditionGroups = [];
    if (strategy.statements) {
      strategy.statements.forEach(function (statement) {
        conditionGroups.push({
          conditions: conditionSerializer.parse(statement.conditions),
          actions: createActionMap(statement.actions)
        });
      });
    }
    if (!strategy.actionList) {
      strategy.actionList = strategyAllocationAuthAvailActionService.getActionList(conditionGroups);
    }
  }
  function parseCustomRule(rule) {
    var ruleLevel = rule.subject.level;
    if (rule.linkObject) {
      rule.linkObject.parsedLevel = conditionsAndActionsService.getLevelByDomain(rule.linkObject.level).label;
      rule.linkObject.parsedConditions = conditionSerializer.deserialize(rule.linkObject.level, rule.type, rule.flowType, rule.linkObject.conditions);
    }
    rule.subject.parsedLevel = conditionsAndActionsService.getLevelByDomain(ruleLevel).label;
    if (rule.subject.conditions) {
      rule.subject.parsedConditions = conditionSerializer.deserialize(ruleLevel, rule.type, rule.flowType, rule.subject.conditions);
    }
  }
  function createActionMap(actionLst) {
    var actionMap = {};
    actionLst.forEach(function (action) {
      actionMap[action.split(' ')[1]] = _.isNil(action.split('\'')[1]) ? _.toInteger(action.split(' ')[3]) : action.split('\'')[1];
    });
    return actionMap;
  }
  return {
    parseRule: parseRule
  };
};
SerializeRuleService.$inject = ['ConditionSerializerService', 'ActionSerializerService', 'RulesService', 'StrategyClosureActionService', 'StrategyAllocationAuthAvailActionService', 'ConditionsAndActionsService', 'StrategyConditionFactory'];
module.exports = SerializeRuleService;